import { WixMediaRoot } from '../../../constants/WixMediaRoot';

export const MAX_NUMBER_OF_ITEMS_IN_COLUMN = 12;

export const ROOT_TITLE_MAP = {
  [WixMediaRoot.Backgrounds]: 'free-from-wix.title.backgrounds',
  [WixMediaRoot.BackgroundImages]: 'free-from-wix.title.backgrounds',
  [WixMediaRoot.BackgroundIllustrations]: 'free-from-wix.title.backgrounds',
  [WixMediaRoot.Patterns]: 'free-from-wix.title.backgrounds',
  [WixMediaRoot.Textures]: 'free-from-wix.title.backgrounds',

  [WixMediaRoot.Clipart]: 'free-from-wix.title.clipart',
  [WixMediaRoot.Illustrations]: 'free-from-wix.title.clipart',

  [WixMediaRoot.FileIcons]: 'free-from-wix.title.file-icons',

  [WixMediaRoot.Photos]: 'free-from-wix.title.photos',
  [WixMediaRoot.Images]: 'free-from-wix.title.photos',

  [WixMediaRoot.Shapes]: 'free-from-wix.title.shapes',
  [WixMediaRoot.BasicShapes]: 'free-from-wix.title.shapes',

  [WixMediaRoot.VectorArt]: 'free-from-wix.title.vector-art',
  [WixMediaRoot.VectorArtNew]: 'free-from-wix.title.vector-art',

  [WixMediaRoot.SocialIcons]: 'free-from-wix.title.social-icons',

  [WixMediaRoot.Videos]: 'free-from-wix.title.videos',
  [WixMediaRoot.VideosPlus]: 'free-from-wix.title.videos',
  [WixMediaRoot.TransparentVideos]: 'free-from-wix.title.videos',
  [WixMediaRoot.Ntt]: 'free-from-wix.title.ntt.images',
};
